export const sidebarData = [
  {
    routeLink: "/#",
    icon: "bx bx-home-circle",
    title: "Dashboard",
  },
  {
    routeLink: "/orders",
    icon: "bx bxs-shopping-bags",
    title: "Orders",
  },
  {
    routeLink: "/products",
    icon: "bx bxs-package",
    title: "Products",
  },
  {
    routeLink: "/reviews",
    icon: "bx bxs-award",
    title: "Reviews",
  },
  // {
  //   routeLink: "/blogs",
  //   icon: "bx bx-file",
  //   title: "Blogs",
  // },
  {
    routeLink: "/stockUpdate",
    icon: "bx bx-store-alt",
    title: "Stock & Offer",
  },
  // {
  //   routeLink: "/location",
  //   icon: "fas fa-location-arrow",
  //   title: "Location",
  // },

  {
    routeLink: "/#",
    icon: "",
    title: "Site settings",
    isSeparator: true,
  },
  {
    routeLink: "/classifications",
    icon: "bx bxs-collection",
    title: "Categories",
  },
  {
    routeLink: "/collections",
    icon: "bx bxs-extension",
    title: "Collections",
  },
  {
    routeLink: "/groups",
    icon: "fas fa-layer-group",
    title: "Groups",
  },
  {
    routeLink: "/pages/all",
    icon: "bx bx-food-menu",
    title: "Pages",
  },

  {
    routeLink: "/banners",
    icon: "bx bxs-image",
    title: "Banners",
  },

  {
    routeLink: "/coupons",
    icon: "bx bxs-coupon",
    title: "Coupon",
  },
  {
    routeLink: "/#",
    icon: "",
    title: "Extras",
    isSeparator: true,
  },
  {
    routeLink: "/users",
    icon: "bx bxs-user",
    title: "Users",
  },
  {
    routeLink: "/promoters",
    icon: "bx bxs-user-voice",
    title: "Promoters",
  },
  {
    routeLink: "/revenues",
    icon: "bx bxs-landmark",
    title: "Revenue",
  },
  {
    routeLink: "/transactions",
    icon: "bx bx-transfer",
    title: "Transactions",
  },
  {
    routeLink: "/performance/product",
    icon: "bx bxs-rocket",
    title: "Performance",
  },
  // {
  //   routeLink: "/#",
  //   icon: "bx bxs-user-voice",
  //   title: "Promoters",
  //   subTitles: [
  //     { title: "All Promoters", routeLink: "/promoters" },
  //     { title: "All Page Views", routeLink: "/all-page-view" },
  //     { title: "All Rewards", routeLink: "/all-earnings" },
  //     { title: "Formated Rewards", routeLink: "/formatted-earnings" },
  //   ],
  // },
  {
    routeLink: "/#",
    icon: "fas fa-location-arrow",
    title: "Location",
    subTitles: [
      { title: "State", routeLink: "/state" },
      { title: "District", routeLink: "/district" },
      { title: "Taluk", routeLink: "/taluks" },
      { title: "Panchayat/Municipality", routeLink: "/lsgs" },
    ],
  },
  {
    routeLink: "/superadmin/settings",
    icon: "bx bxs-check-shield",
    title: "Admin Settings",
  },
]

export const promoterDashboard = [
  { title: "Dashboard", routeLink: "/dashboard", icon: "bx bxs-home" },

  {
    title: "Profile",
    routeLink: "/promoter-profile",
    icon: "bx bx-user",
  },

  {
    title: "Orders",
    routeLink: "/orders",
    icon: "bx bxs-shopping-bags",
  },
  {
    title: " Page Views",
    routeLink: "/promoter-page-view",
    icon: "bx bx-show-alt",
  },
  {
    title: " Earnings",
    routeLink: "/promoter-earnigs",
    icon: "bx bx-dollar",
  },
  {
    title: "Products",
    routeLink: "/promoter/products",
    icon: "bx bxs-package",
  },
]
